<template>
  <div class="container">
    <div class="main">
      <h3  style="color: #000;font-size: 18px;padding: 20px 0;">{{sysparam.homesectitle3 ?
        sysparam.homesectitle3.sysparambeg : ''}}</h3>

      <div class="box">
        <div class="item" v-for="cu in cuList" @click="link(cu.cuaddr)">
          <img v-if="cu.culogo" :src="picAddr + cu.culogo.replace('/upload/', '')"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        cuList: []
      }
    },
    created () {
      this.findCuList()
    },
    methods: {
      findCuList () {
        this.$store.dispatch('findCuList').then(list => {
          this.cuList = list
        })
      },
      link (addr) {
        if (addr) {
          window.open(addr, '_blank')
        }
      }
    },
    components: {},
    computed: mapState({
      picAddr: state => state.picAddr,
      sysparam: state => state.sysparam
    })
  }
</script>

<style lang="stylus" scoped>
  .container {
    display flex
    justify-content center
    .main {
      width 1246px;
      .box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .item {
          margin:0 10px 10px 0;
          display flex;
          align-items center
          justify-content center
          border: 1px solid #ddd;
          width: 18%;
          height: 80px;
          img {
            padding  5px;
            cursor: pointer;
            width: 100%;
            max-height: 68px;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// Sy.vue?bb9018e8